import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Wrapper from './layout/wrapper';
import ScrollToTop from './components/ScrollToTop';

// Solo se declaran las paginas alcanzables navegando desde el menu o el pie.
// El resto de vistas siguen en src/views/pages pero no tienen ruta publicada:
// cualquier URL antigua cae en NotFound. Ver reports/2026-09-22-paginas-huerfanas.md
//
// Al publicar una pagina hay que añadirla TAMBIEN en public/serve.json, o el
// servidor respondera 404 aunque la ruta exista aqui.
//
// Excepcion: src/views/pages/RobotsTxt.jsx NO debe volver a enrutarse. Servia
// robots.txt como HTML (ningun buscador lo leia) y esta sustituida por el
// fichero real public/robots.txt; reenrutarla lo taparia.
const Home = lazy(() => import('./views/pages/Home'));
const Contact = lazy(() => import('./views/pages/Contact'));
const AutoDigitalTwins = lazy(() => import('./views/pages/AutoDigitalTwins'));
const FondosEuropeos = lazy(() => import('./views/pages/FondosEuropeos'));
const NeuronDones = lazy(() => import('./views/pages/NeuronDones'));
const PrivacyPolicy = lazy(() => import('./views/pages/PrivacyPolicy'));
const SobreNosotros = lazy(() => import('./views/pages/SobreNosotros'));
const RtExplore = lazy(() => import('./views/pages/RtExplore'));
// Se mantiene publicada por precaucion: si su URL se declaro como evidencia de
// publicidad en la justificacion de la ayuda InnoCamaras, retirarla tocaria una
// obligacion. Pendiente de confirmar; si no consta, se retira como las demas.
const Innocamara = lazy(() => import('./views/pages/Innocamara'));
const NotFound = lazy(() => import('./views/pages/NotFound'));

const Loading = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="text-white text-lg">Loading...</div>
  </div>
);

function App() {
  return (
    <Wrapper>
      <ScrollToTop />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/auto-digital-twins" element={<AutoDigitalTwins />} />
          <Route path="/neuron-dones" element={<NeuronDones />} />
          <Route path="/rt-explore" element={<RtExplore />} />
          <Route path="/european-funds" element={<FondosEuropeos />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/innocamara" element={<Innocamara />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Wrapper>
  );
}

export default App;
